export default __webpack_public_path__ + "static/media/hoverPokemonSound.129673dd.mp3";